export default __webpack_public_path__ + "static/media/AdobeStock_446468837.1c6985f1.jpeg";